import script from "./PosFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PosFooter.vue?vue&type=script&setup=true&lang=js"

import "./PosFooter.vue?vue&type=style&index=0&id=994ee990&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-994ee990"]])

export default __exports__